import { useEffect, useState } from 'react';
import { DEVICE_SIZES } from '@exonet/react-shared/lib/styled';

const getMonths = (width) => {
  if (width < DEVICE_SIZES.XS.replace('px', '')) return 1;
  if (width < DEVICE_SIZES.SM.replace('px', '')) return 2;
  return 3;
};

export default () => {
  const [numberOfMonths, setNumberOfMonths] = useState(getMonths(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setNumberOfMonths(getMonths(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return numberOfMonths;
};
